import React, { Component } from 'react';
import { connect } from 'react-redux';
import TopMenuItem from './TopMenuItem.jsx';
import SideMenuItem from './SideMenuItem.jsx';
import { Link } from 'react-router-dom';
import qs from 'qs';
import axios from 'axios';
import fetchMe from '../../actions/fetchMe';
import setSiteOptions from '../../actions/setSiteOptions';
import { NavLink } from 'react-router-dom';
import MyAvatar from '../Helpers/MyAvatar.jsx';
import MarketMiniCart from '../Market/MarketMiniCart';
import Checkbox from '../Helpers/Filter/Inputs/Checkbox';
import LangSelector from "../LangSelector";
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router';
import { custom } from "../../utils/linker";

class TopMenu extends Component {
  constructor(props) {
    super(props);
    this.state={
      show_my:false,
    }
  }
  renderMenu() {
    let topMenu;
    const t=this.props.translateStore.t;
    if (this.props.meStore.me.data) {
      topMenu = [
        {name: t.menu.home, route: '/'},
        {name: t.lk.PRIVATE_MESSAGES, route: '/chat/', regexp: '^/chat.*$'},
        {name: t.lk.LAST_COMMENTS, route: '/last_comments/my/', regexp: '^/last_comments.*$'},
        {name: t.lk.spying_title, route: '/spying/all/', regexp: '^/spying.*$'},
        {name: t.menu.blogspot, route: '/blog/my/', regexp: '^/blog.*$'},
        {name: t.menu.photospot, route: '/photospot/my/', regexp: '^/photospot.*$'},
        {name: t.menu.figures, route: '/figures/my/', regexp: '^/figures.*$'},
        {name: t.menu.anime, route: '/anime/my/', regexp: '^/anime.*$'},
        {name: t.menu.character, route: '/characters/', regexp: '^/characters.*$'},
        {name: t.menu.users, route: '/shelf/', regexp: '^/shelf.*$'},
        {name: t.evaMarket.market, route: '/market/', regexp: '^/market.*$'},
      ];
      if(
        this.props.meStore.me.data.roles.admin || this.props.meStore.me.data.roles.figure_moderator  ||
        this.props.meStore.me.data.roles.figure_super_moderator  || this.props.meStore.me.data.roles.figure_adder ||
        this.props.meStore.me.data.roles.anime_moderator  || this.props.meStore.me.data.roles.anime_super_moderator  ||
        this.props.meStore.me.data.roles.characters_moderator  || this.props.meStore.me.data.roles.characters_super_moderator
      ) {
        topMenu.push({name: "Moderation", route: '/moderation/', regexp: '^/moderation.*$'});
      }
    } else {
      topMenu = [
        {name: t.menu.home, route: '/'},
        {name: t.menu.blogspot, route: '/blog/', regexp: '^/blog.*$'},
        {name: t.menu.photospot, route: '/photospot/', regexp: '^/photospot.*$'},
        {name: t.menu.figures, route: '/figures/', regexp: '^/figures.*$'},
        {name: t.menu.anime, route: '/anime/', regexp: '^/anime.*$'},
        {name: t.menu.character, route: '/characters/', regexp: '^/characters.*$'},
        {name: t.menu.users, route: '/shelf/', regexp: '^/shelf.*$'},
        {name: t.evaMarket.market, route: '/market/', regexp: '^/market.*$'},
      ];
    }

    if (topMenu && topMenu.length) {
      return topMenu.map((item) => {
        if (this.props.meStore.me.data) {
          item.to += '/my';
        }
        return (
          <SideMenuItem key={item.name} {...item} />
        )
      });
    }
    return null;
  }
  clickOnMy() {
    this.setState({ show_my:!this.state.show_my });
  }
  renderMyItems() {
    const myMenu=[
      {name:'Shelf',route:`/shelf/${this.props.meStore.me.data.nick}`},
      {name:'Figures',route:`/shelf/${this.props.meStore.me.data.nick}/figures`},
      {name:'Anime',route:`/shelf/${this.props.meStore.me.data.nick}/anime`},
      {name:'Photos',route:`/shelf/${this.props.meStore.me.data.nick}/photos`},
      {name:'Spying',route:`/shelf/${this.props.meStore.me.data.nick}/spying`},
    ];

    return myMenu.map((item)=>{
      return (
        <NavLink key={item.route} className="w1 clear tdni db hpadd20 vpadd10 " activeClassName="bg-b1" exact to={item.route}>{item.name}</NavLink>
      )
    })
  }
  renderMy() {
    return (
      <div className="menuHeight pr" onClick={()=>{ this.clickOnMy(); }}>
        <div className="up12 splice h100">
          <div className="cell s-middle s-12">
            <span className="font1  pointer fs20 dib">
              My <i className="mdi mdi-chevron-down"></i>
            </span>
          </div>
        </div>
        <div className="pa bg-b2 clear tdni w1" style={{zIndex:9,top:'100%', display:this.state.show_my?'block':'none', left:0}}>
          {this.renderMyItems()}
        </div>
      </div>
    );
  }
  renderLamp() {
    return (
      <div>
        <label>
          <Checkbox code="market_published" value="1" {...custom(this.props.appStateStore,"site_tpl")} />
          <span className="vam dib pleft5">Включить фон</span>
        </label>
      </div>
    )
  }
  render() {
    return (
      <div>
        <div className="sideMenuWidth blank"></div>
        <div className={`sideMenuWidth filled pf trans03 pa-tl h100vh ofa bg-w1 ${this.props.mobile_menu_open?'opened':null}`} style={{zIndex:901}}>
          <div className="pr w100 h100">
            <div className="pa pa-tl w100 h100 sideMenuBg"><div></div></div>
            <div className="pr">
              <MyAvatar />
              {/*<MarketMiniCart />*/}
              {this.renderMenu()}
              <div className="ptop20 pleft20">
                {this.renderLamp()}
              </div>
              <div className="ptop20 ofh">
                <LangSelector />
              </div>

            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    menu:state.menu,
    router:state.router,
    me:state.me,
    mobile_menu_open:state.mobile_menu_open,
    site_options:state.site_options,
    t:state.translate,
  }
}


// export default connect(mapStateToProps, { fetchMe,setSiteOptions }, null, { pure: false })(TopMenu);
export default withRouter(inject("translateStore","appStateStore","router","meStore")(observer(TopMenu)));
